import { Box, Icon, IconProps } from '@chakra-ui/react';

const AddPanelsIcon = ({ boxSize = 10, ...props }: IconProps) => (
  <Icon viewBox="0 0 34 35" {...props} boxSize={boxSize} fill="none">
    <path
      d="M16.712 2.69519V32.3691"
      stroke="white"
      strokeWidth="3.542"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.5489 17.5322H1.875"
      stroke="white"
      strokeWidth="3.542"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

const RemovePanelsIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 46 46"
    {...props}
    fill="none"
    color="var(--chakra-colors-primaryColor)"
  >
    <circle cx="23" cy="23" r="23" fill="white" />
    <path
      d="M34.6875 14.2188H11.3125"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8125 20.4062V28.6562"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.1875 20.4062V28.6562"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5625 14.2188V33.8125C32.5625 34.086 32.4506 34.3483 32.2513 34.5417C32.052 34.7351 31.7818 34.8438 31.5 34.8438H14.5C14.2182 34.8438 13.948 34.7351 13.7487 34.5417C13.5494 34.3483 13.4375 34.086 13.4375 33.8125V14.2188"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.3125 14.2188V12.1562C28.3125 11.6092 28.0886 11.0846 27.6901 10.6978C27.2916 10.311 26.7511 10.0938 26.1875 10.0938H19.8125C19.2489 10.0938 18.7084 10.311 18.3099 10.6978C17.9114 11.0846 17.6875 11.6092 17.6875 12.1562V14.2188"
      stroke="currentColor"
      strokeWidth="2.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

// const RoofIcon = (props: IconProps) => (
//   <Icon as={MdChevronRight} {...props} color="red" />
// );
const RoofIcon = (props: IconProps) => (
  <Icon viewBox="0 0 14 11" {...props} fill="white">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.19751 10.8657L0.69751 0.865723L13.6975 0.865723L7.19751 10.8657Z"
      fill="#FF0000"
    />
  </Icon>
);

const PanelLineGrabIcon = ({
  size = 50,
  color = 'primaryColor',
}: {
  size: number;
  color: string;
}) => (
  <Box
    bg="white"
    border={`solid ${size / 3}px`}
    borderColor={color}
    borderRadius={size}
    width={size}
    height={size}
  />
);

const SummeryRoofIcon = ({ boxSize = 10, ...props }: IconProps) => (
  <Icon viewBox="0 0 40 35" {...props} boxSize={boxSize} fill="none">
    <path
      d="M31.3245 15.3777V33H8.67578V15.3777"
      stroke="#010202"
      strokeWidth="2.8335"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3142 1.47766L19.8176 1L19.326 1.48314L2.51658 17.9929L2 18.4999L2.52208 19.002L4.58542 20.9848L5.08202 21.4624L5.57362 20.9793L19.8501 6.95736L34.4539 20.9957L34.9505 21.4729L35.4426 20.9902L37.4834 18.986L38 18.4785L37.4779 17.977L20.3142 1.47766Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3142 1.47766L19.8176 1L19.326 1.48314L2.51658 17.9929L2 18.4999L2.52208 19.002L4.58542 20.9848L5.08202 21.4624L5.57362 20.9793L19.8501 6.95736L34.4539 20.9957L34.9505 21.4729L35.4426 20.9902L37.4834 18.986L38 18.4785L37.4779 17.977L20.3142 1.47766Z"
      stroke="white"
      strokeWidth="1.4165"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1233 33H23.5386V31.5899V27.0083C23.5386 24.8672 21.7961 23.1312 19.6463 23.1312C17.4965 23.1312 15.7534 24.8672 15.7534 27.0083V31.5899V33H17.1688H22.1233Z"
      stroke="#010202"
      strokeWidth="2.8335"
    />
  </Icon>
);

const SummaryLocationIcon = ({
  boxSize = 10,
  outsideColor,
  insideColor,
  ...props
}: { outsideColor: string; insideColor: string } & IconProps) => (
  <Icon viewBox="0 0 35 40" {...props} boxSize={boxSize} fill="none">
    <mask
      id="mask0_0_133"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="35"
      height="40"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H35V40H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_0_133)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.12514 4.85278C-1.70903 11.3232 -1.70903 21.8142 5.12514 28.2846C5.13463 28.2936 5.14411 28.3025 5.15359 28.3115L5.16096 28.3175L17.4998 40.0005L29.7975 28.3574L27.446 26.1202L17.4998 35.537L7.55983 26.1261L7.55456 26.1202C7.54613 26.1132 7.53876 26.1062 7.53138 26.0982C2.02569 20.8866 2.02569 12.4353 7.53138 7.2227C13.0371 2.01009 21.9635 2.01009 27.4692 7.2227C32.9749 12.4353 32.9749 20.8866 27.4692 26.0982C27.4608 26.1062 27.4534 26.1132 27.446 26.1202L29.7975 28.3574L29.8386 28.3175L29.846 28.3115C29.8554 28.3025 29.8649 28.2936 29.8744 28.2846C36.7086 21.8142 36.7086 11.3232 29.8744 4.85278C23.0402 -1.61759 11.9593 -1.61759 5.12514 4.85278Z"
        fill={outsideColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4999 11.1737C20.4413 11.1737 22.8254 13.4309 22.8254 16.2158C22.8254 19.0006 20.4413 21.2588 17.4999 21.2588C14.5584 21.2588 12.1743 19.0006 12.1743 16.2158C12.1743 13.4309 14.5584 11.1737 17.4999 11.1737Z"
        stroke={insideColor}
        strokeWidth="3.37"
      />
    </g>
  </Icon>
);

const SummaryChoiceIcon = ({ boxSize = 10, ...props }: IconProps) => (
  <Icon viewBox="0 0 34 34" {...props} boxSize={boxSize} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.71 12.517V12.517C22.973 13.7654 22.973 15.7896 21.71 17.038L7.52144 31.0637C6.2585 32.3121 4.21065 32.3121 2.9472 31.0637V31.0637C1.68427 29.8148 1.68427 27.7906 2.9472 26.5422L17.1363 12.517C18.3992 11.2686 20.4471 11.2686 21.71 12.517Z"
      stroke="#010202"
      strokeWidth="2.8385"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6465 28.4947L13.1549 28.9973L13.6628 28.4947L15.696 26.4855L16.2039 25.9829L15.696 25.4803L8.84402 18.7078L8.33611 18.2057L7.82769 18.7078L5.79504 20.7175L5.28662 21.2196L5.79504 21.7221L12.6465 28.4947Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6465 28.4947L13.1549 28.9973L13.6628 28.4947L15.696 26.4855L16.2039 25.9829L15.696 25.4803L8.84402 18.7078L8.33611 18.2057L7.82769 18.7078L5.79504 20.7175L5.28662 21.2196L5.79504 21.7221L12.6465 28.4947Z"
      stroke="white"
      strokeWidth="1.4195"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.0347 2.00929C25.1224 0.7709 21.5807 1.35605 19.1622 3.74623C16.0124 6.86021 15.9613 11.8583 19.0488 14.9102C22.1362 17.9621 27.1931 17.9121 30.3433 14.7986C32.7613 12.4079 33.3533 8.9065 32.1005 6.02828L26.5753 11.4894C26.3484 11.7141 25.9797 11.7141 25.7524 11.4894L22.5094 8.28381C22.2826 8.05956 22.2826 7.69515 22.5094 7.4704L28.0347 2.00929Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.1973 2.80473C23.4077 2.72815 21.571 3.37487 20.179 4.75091C17.571 7.32929 17.5589 11.4274 20.0655 13.9057C22.5727 16.3839 26.719 16.3714 29.3269 13.7935C30.719 12.4175 31.3732 10.602 31.2958 8.83298L27.592 12.4941C26.8036 13.2739 25.5249 13.2739 24.7365 12.4941L21.4935 9.28849C20.7051 8.50911 20.7051 7.2452 21.4935 6.46583L25.1973 2.80473ZM30.2298 1.84866L24.1313 7.87741L26.1645 9.88666L32.263 3.85841L33.1735 5.73651C34.6562 9.14382 34.1984 12.9971 31.3596 15.8033C27.6675 19.4529 21.7007 19.541 18.0329 15.9149C14.3651 12.2893 14.4542 6.39125 18.1463 2.74166C20.9846 -0.0644786 24.6955 -0.702693 28.1425 0.763448L30.2298 1.84866Z"
      fill="#010202"
    />
  </Icon>
);

const SummaryFormIcon = ({ boxSize = 8, ...props }: IconProps) => (
  <Icon viewBox="0 0 28 35" {...props} boxSize={boxSize} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.111 33H26.5556V31.565V8.9675V8.42465L26.1943 8.01827L20.7776 1.92055L20.3461 1.43481H19.6943H3.44463H2V2.86978V31.565V33H3.44463H25.111Z"
      stroke="black"
      strokeWidth="2.8385"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33339 14.3479H5.61133V15.0651V17.9346V18.6518H6.33339H22.2223H22.9443V17.9346V15.0651V14.3479H22.2223H6.33339Z"
      fill="var(--chakra-colors-primaryColor)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33339 14.3479H5.61133V15.0651V17.9346V18.6518H6.33339H22.2223H22.9443V17.9346V15.0651V14.3479H22.2223H6.33339Z"
      stroke="white"
      strokeWidth="1.4195"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33339 20.0869H5.61133V20.8041V23.6741V24.3913H6.33339H17.8889H18.6109V23.6741V20.8041V20.0869H17.8889H6.33339Z"
      fill="var(--chakra-colors-primaryColor)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.33339 20.0869H5.61133V20.8041V23.6741V24.3913H6.33339H17.8889H18.6109V23.6741V20.8041V20.0869H17.8889H6.33339Z"
      stroke="white"
      strokeWidth="1.4195"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1665 0V10.761H27.9999V7.89104H20.0553V0H17.1665Z"
      fill="#010202"
    />
  </Icon>
);

const NorthIcon = ({ boxSize = 8, ...props }: IconProps) => (
  <Icon viewBox="0 0 43 43" {...props} boxSize={boxSize} fill="none">
    <mask
      id="mask0_0_638"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="43"
      height="43"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H42.019V42.019H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_0_638)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0095 42.019C9.40651 42.019 -0.000488281 32.613 -0.000488281 21.009V0H42.0195V21.009C42.0195 32.613 32.6125 42.019 21.0095 42.019Z"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8157 9.81631L21.3627 2.44031L23.8547 9.81631H18.8157Z"
      fill="var(--chakra-colors-primaryColor)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3914 13.7375H17.3554L24.2034 22.7355V13.7375H27.3754V28.3505H24.6404L17.5644 19.0615V28.3505H14.3914V13.7375Z"
      fill="var(--chakra-colors-primaryColor)"
    />
  </Icon>
);

const SouthIcon = ({ boxSize = 8, ...props }: IconProps) => (
  <Icon viewBox="0 0 43 43" {...props} boxSize={boxSize} fill="none">
    <mask
      id="mask0_0_644"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="43"
      height="43"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H42.0189V42.019H0V0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_0_644)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.019 42.019H0V21.009C0 9.406 9.406 0 21.009 0C32.613 0 42.019 9.406 42.019 21.009V42.019Z"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5829 32.3571L21.0359 39.7331L18.5439 32.3571H23.5829Z"
      fill="#00922A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8882 26.1424L16.8672 23.7734C18.2372 24.9024 19.6732 25.6214 21.4122 25.6214C22.7822 25.6214 23.6092 25.0784 23.6092 24.1854V24.1414C23.6092 23.2934 23.0872 22.8594 20.5422 22.2064C17.4762 21.4234 15.4972 20.5754 15.4972 17.5524V17.5104C15.4972 14.7474 17.7152 12.9204 20.8252 12.9204C23.0432 12.9204 24.9352 13.6164 26.4792 14.8554L24.7402 17.3794C23.3912 16.4444 22.0652 15.8794 20.7822 15.8794C19.4992 15.8794 18.8242 16.4654 18.8242 17.2054V17.2474C18.8242 18.2484 19.4772 18.5744 22.1082 19.2484C25.1962 20.0544 26.9362 21.1634 26.9362 23.8154V23.8594C26.9362 26.8824 24.6312 28.5794 21.3472 28.5794C19.0422 28.5794 16.7152 27.7734 14.8882 26.1424Z"
      fill="#00922A"
    />
  </Icon>
);

const LocationIcon = ({ boxSize = 35, ...props }: IconProps) => (
  <Icon viewBox="0 0 34 35" {...props} boxSize={boxSize} fill="none">
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_826_364)">
        <mask id="path-1-inside-1_826_364" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.8525 24.1908C26.86 24.1833 26.8675 24.1758 26.875 24.1683C32.3748 18.6685 32.3748 9.75146 26.875 4.2516C21.3751 -1.24825 12.4581 -1.24825 6.95823 4.2516C1.45838 9.75146 1.45838 18.6685 6.95823 24.1683C6.96572 24.1758 6.97322 24.1833 6.98072 24.1908L16.9166 34.1267L26.8525 24.1908Z"
          />
        </mask>
        <path
          d="M26.8525 24.1908L24.8534 22.183L24.849 22.1873L26.8525 24.1908ZM26.875 4.2516L24.8715 6.25507L26.875 4.2516ZM6.95823 4.2516L4.95477 2.24813L6.95823 4.2516ZM6.95823 24.1683L4.95477 26.1718L4.95489 26.1719L6.95823 24.1683ZM6.98072 24.1908L8.9842 22.1873L8.97978 22.1829L6.98072 24.1908ZM16.9166 34.1267L14.9131 36.1301L16.9166 38.1336L18.9201 36.1301L16.9166 34.1267ZM24.8715 22.1649C24.8655 22.1708 24.8595 22.1769 24.8534 22.183L28.8516 26.1986C28.8605 26.1898 28.8694 26.1808 28.8784 26.1718L24.8715 22.1649ZM24.8715 6.25507C29.2649 10.6484 29.2649 17.7715 24.8715 22.1649L28.8784 26.1718C35.4848 19.5655 35.4848 8.85447 28.8784 2.24813L24.8715 6.25507ZM8.9617 6.25507C13.3551 1.8617 20.4781 1.8617 24.8715 6.25507L28.8784 2.24813C22.2721 -4.35821 11.5611 -4.35821 4.95477 2.24813L8.9617 6.25507ZM8.9617 22.1649C4.56833 17.7715 4.56833 10.6484 8.9617 6.25507L4.95477 2.24813C-1.65158 8.85447 -1.65158 19.5655 4.95477 26.1718L8.9617 22.1649ZM8.97978 22.1829C8.97373 22.1769 8.96766 22.1708 8.96158 22.1647L4.95489 26.1719C4.96379 26.1808 4.97271 26.1897 4.98166 26.1986L8.97978 22.1829ZM18.9201 32.1232L8.98419 22.1873L4.97725 26.1942L14.9131 36.1301L18.9201 32.1232ZM24.849 22.1873L14.9131 32.1232L18.9201 36.1301L28.856 26.1942L24.849 22.1873Z"
          fill="var(--chakra-colors-secondaryColor)"
          mask="url(#path-1-inside-1_826_364)"
        />
        <circle
          cx="17"
          cy="14.2934"
          r="4.25"
          stroke="var(--chakra-colors-primaryColor)"
          strokeWidth="2.83333"
        />
      </g>
      <defs>
        <clipPath id="clip0_826_364">
          <rect
            width="34"
            height="34"
            fill="white"
            transform="translate(0 0.126709)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

const EditIcon = ({ boxSize = 8, ...props }: IconProps) => (
  <Icon viewBox="0 0 26 26" {...props} boxSize={boxSize} fill="none">
    <circle cx="13" cy="13" r="13" fill="currentColor" />
    <path
      d="M7.91309 19.047H17.7587"
      stroke="white"
      strokeWidth="0.9792"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4849 16.0451L8.23584 17.0086L9.16428 13.6362L15.4301 7.13199C15.8787 6.66629 16.6059 6.66629 17.0546 7.13199L17.7507 7.85457C18.1993 8.32028 18.1993 9.07522 17.7507 9.54093L11.4849 16.0451Z"
      stroke="white"
      strokeWidth="0.9792"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8221 10.5046L14.5015 8.0957"
      stroke="white"
      strokeWidth="0.9792"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

const RotatePanelIcon = ({ boxSize = 26, ...props }: IconProps) => (
  <Icon viewBox="0 0 26 27" {...props} boxSize={boxSize} fill="none">
    <mask id="path-1-inside-1_247_26" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0.564414C16 0.252697 16.2527 -4.08768e-08 16.5644 0L19.0729 3.28952e-07C21.4628 6.4234e-07 23.4001 1.93734 23.4001 4.32718L23.4001 6.83569C23.4001 7.1474 23.1474 7.4001 22.8357 7.4001C22.524 7.4001 22.2713 7.1474 22.2713 6.83569V4.32718C22.2713 2.56078 20.8393 1.12883 19.0729 1.12883L16.5644 1.12883C16.2527 1.12883 16 0.876132 16 0.564414Z"
      />
      <path d="M23.0801 9.54801C22.9715 9.73615 22.6999 9.73615 22.5913 9.54801L20.3645 5.69118C20.2559 5.50304 20.3917 5.26787 20.6089 5.26787L25.0624 5.26787C25.2797 5.26787 25.4155 5.50304 25.3068 5.69118L23.0801 9.54801Z" />
      <path d="M16 5.00009C16.9428 5.00009 17.4142 5.00009 17.7071 5.29298C18 5.58587 18 6.05728 18 7.00009V25.0001C18 25.9429 18 26.4143 17.7071 26.7072C17.4142 27.0001 16.9428 27.0001 16 27.0001L2 27.0001C1.05719 27.0001 0.585786 27.0001 0.292893 26.7072C-5.96046e-08 26.4143 -4.11803e-08 25.9429 0 25.0001L7.86836e-07 7.00009C8.28048e-07 6.05728 8.34465e-07 5.58587 0.292894 5.29298C0.585787 5.00009 1.05719 5.00009 2 5.00009L16 5.00009Z" />
    </mask>
    <path
      d="M16.5644 0L16.5644 2L16.5644 0ZM19.0729 3.28952e-07L19.0729 -2L19.0729 3.28952e-07ZM23.4001 4.32718L25.4001 4.32718L25.4001 4.32718L23.4001 4.32718ZM23.4001 6.83569L21.4001 6.83568L21.4001 6.83569L23.4001 6.83569ZM22.2713 6.83569L24.2713 6.83569V6.83569H22.2713ZM22.2713 4.32718L20.2713 4.32718V4.32718H22.2713ZM19.0729 1.12883L19.0729 3.12883L19.0729 1.12883ZM16.5644 1.12883L16.5644 -0.871171L16.5644 1.12883ZM25.0624 5.26787L25.0624 7.26787L25.0624 5.26787ZM25.3068 5.69118L27.0389 6.69118L27.0389 6.69118L25.3068 5.69118ZM20.3645 5.69118L18.6325 6.69118L18.6325 6.69118L20.3645 5.69118ZM20.6089 5.26787L20.6089 3.26787L20.6089 5.26787ZM22.5913 9.54801L24.3233 8.54801L24.3233 8.54801L22.5913 9.54801ZM23.0801 9.54801L21.348 8.54801L21.348 8.54801L23.0801 9.54801ZM7.86836e-07 7.00009L-2 7.00009L7.86836e-07 7.00009ZM2 5.00009L2 3.00009L2 3.00009L2 5.00009ZM2 27.0001L2 25.0001L2 25.0001L2 27.0001ZM0 25.0001L-2 25.0001L0 25.0001ZM18 25.0001L20 25.0001V25.0001H18ZM16 27.0001L16 29.0001L16 29.0001L16 27.0001ZM18 7.00009L16 7.00009V7.00009H18ZM16 5.00009L16 7.00009L16 7.00009L16 5.00009ZM16.5644 -2C15.1481 -2 14 -0.851875 14 0.564414L18 0.564414C18 1.35727 17.3573 2 16.5644 2L16.5644 -2ZM19.0729 -2L16.5644 -2L16.5644 2L19.0729 2L19.0729 -2ZM25.4001 4.32718C25.4001 0.832772 22.5673 -2 19.0729 -2L19.0729 2C20.3582 2 21.4001 3.04191 21.4001 4.32718L25.4001 4.32718ZM25.4001 6.83569L25.4001 4.32718L21.4001 4.32718L21.4001 6.83568L25.4001 6.83569ZM22.8357 9.4001C24.252 9.4001 25.4001 8.25197 25.4001 6.83569L21.4001 6.83569C21.4001 6.04283 22.0428 5.4001 22.8357 5.4001L22.8357 9.4001ZM20.2713 6.83569C20.2713 8.25197 21.4194 9.4001 22.8357 9.4001L22.8357 5.4001C23.6285 5.4001 24.2713 6.04284 24.2713 6.83569L20.2713 6.83569ZM20.2713 4.32718V6.83569H24.2713V4.32718H20.2713ZM19.0729 3.12883C19.7348 3.12883 20.2713 3.66535 20.2713 4.32718L24.2713 4.32718C24.2713 1.45621 21.9439 -0.871171 19.0729 -0.871171L19.0729 3.12883ZM16.5644 3.12883L19.0729 3.12883L19.0729 -0.871171L16.5644 -0.871171L16.5644 3.12883ZM14 0.564414C14 1.9807 15.1481 3.12883 16.5644 3.12883L16.5644 -0.871171C17.3573 -0.871171 18 -0.228441 18 0.564414L14 0.564414ZM24.3233 8.54801L22.0966 4.69118L18.6325 6.69118L20.8592 10.548L24.3233 8.54801ZM20.6089 7.26787L25.0624 7.26787L25.0624 3.26787L20.6089 3.26787L20.6089 7.26787ZM23.5748 4.69118L21.348 8.54801L24.8121 10.548L27.0389 6.69118L23.5748 4.69118ZM25.0624 7.26787C23.7401 7.26787 22.9136 5.83637 23.5748 4.69118L27.0389 6.69118C27.9173 5.16972 26.8193 3.26787 25.0624 3.26787L25.0624 7.26787ZM22.0966 4.69118C22.7578 5.83639 21.9313 7.26787 20.6089 7.26787L20.6089 3.26787C18.8521 3.26787 17.7541 5.1697 18.6325 6.69118L22.0966 4.69118ZM20.8592 10.548C21.7377 12.0695 23.9337 12.0695 24.8121 10.548L21.348 8.54801C22.0092 7.40283 23.6622 7.4028 24.3233 8.54801L20.8592 10.548ZM16 7.00009V25.0001H20V7.00009H16ZM16 25.0001L2 25.0001L2 29.0001L16 29.0001L16 25.0001ZM2 25.0001L2 7.00009L-2 7.00009L-2 25.0001L2 25.0001ZM2 7.00009L16 7.00009L16 3.00009L2 3.00009L2 7.00009ZM2 7.00009C2 6.75695 2.00013 6.57818 2.00394 6.42725C2.00778 6.2753 2.0145 6.20116 2.01878 6.16931C2.02289 6.13875 2.0179 6.20286 1.97315 6.31164C1.92183 6.43639 1.83511 6.57919 1.70711 6.70719L-1.12132 3.87877C-1.7013 4.45875 -1.87912 5.14223 -1.94555 5.63632C-2.00425 6.07288 -2 6.58522 -2 7.00009L2 7.00009ZM2 3.00009C1.58514 3.00009 1.07279 2.99584 0.636233 3.05453C0.142142 3.12096 -0.541335 3.29878 -1.12132 3.87877L1.70711 6.70719C1.57911 6.8352 1.4363 6.92191 1.31156 6.97324C1.20278 7.01799 1.13866 7.02297 1.16922 7.01886C1.20107 7.01458 1.27522 7.00786 1.42716 7.00403C1.5781 7.00022 1.75686 7.00009 2 7.00009L2 3.00009ZM2 25.0001C1.75686 25.0001 1.5781 25 1.42716 24.9961C1.27521 24.9923 1.20107 24.9856 1.16922 24.9813C1.13866 24.9772 1.20278 24.9822 1.31155 25.0269C1.4363 25.0783 1.5791 25.165 1.70711 25.293L-1.12132 28.1214C-0.541335 28.7014 0.142144 28.8792 0.636235 28.9456C1.07279 29.0043 1.58514 29.0001 2 29.0001L2 25.0001ZM-2 25.0001C-2 25.415 -2.00425 25.9273 -1.94555 26.3639C-1.87913 26.8579 -1.70131 27.5414 -1.12132 28.1214L1.70711 25.293C1.83511 25.421 1.92183 25.5638 1.97315 25.6885C2.0179 25.7973 2.02289 25.8614 2.01878 25.8309C2.0145 25.799 2.00777 25.7249 2.00394 25.5729C2.00013 25.422 2 25.2432 2 25.0001L-2 25.0001ZM16 25.0001C16 25.2432 15.9999 25.422 15.9961 25.5729C15.9922 25.7249 15.9855 25.799 15.9812 25.8309C15.9771 25.8614 15.9821 25.7973 16.0268 25.6885C16.0782 25.5638 16.1649 25.421 16.2929 25.293L19.1213 28.1214C19.7013 27.5414 19.8791 26.8579 19.9456 26.3639C20.0042 25.9273 20 25.415 20 25.0001L16 25.0001ZM16 29.0001C16.4149 29.0001 16.9272 29.0043 17.3638 28.9456C17.8579 28.8792 18.5413 28.7014 19.1213 28.1214L16.2929 25.293C16.4209 25.165 16.5637 25.0783 16.6884 25.0269C16.7972 24.9822 16.8613 24.9772 16.8308 24.9813C16.7989 24.9856 16.7248 24.9923 16.5728 24.9961C16.4219 25 16.2431 25.0001 16 25.0001L16 29.0001ZM20 7.00009C20 6.58522 20.0042 6.07288 19.9456 5.63632C19.8791 5.14223 19.7013 4.45875 19.1213 3.87877L16.2929 6.70719C16.1649 6.57919 16.0782 6.43638 16.0268 6.31164C15.9821 6.20286 15.9771 6.13875 15.9812 6.16931C15.9855 6.20115 15.9922 6.2753 15.9961 6.42725C15.9999 6.57818 16 6.75695 16 7.00009L20 7.00009ZM16 7.00009C16.2431 7.00009 16.4219 7.00022 16.5728 7.00403C16.7248 7.00786 16.7989 7.01458 16.8308 7.01886C16.8613 7.02297 16.7972 7.01799 16.6884 6.97324C16.5637 6.92192 16.4209 6.8352 16.2929 6.70719L19.1213 3.87877C18.5413 3.29878 17.8579 3.12096 17.3638 3.05453C16.9272 2.99584 16.4149 3.00009 16 3.00009L16 7.00009Z"
      fill="white"
      mask="url(#path-1-inside-1_247_26)"
    />
  </Icon>
);

const CalendarCheckmarkIcon = ({ boxSize = 32, ...props }: IconProps) => (
  <Icon viewBox="0 0 32 32" {...props} boxSize={boxSize} fill="none">
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 3V7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3V7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 11H27"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 16L14.6625 21.5L11.5 18.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

const CheckMarkIcon = ({ boxSize = 14, ...props }: IconProps) => (
  <Icon viewBox="0 0 14 14" {...props} boxSize={boxSize} fill="none">
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.73022" cy="6.73022" r="6.73022" fill="white" />
      <g clipPath="url(#clip0_712_2906)">
        <mask
          id="mask0_712_2906"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="4"
          width="8"
          height="6"
        >
          <path
            d="M5.87291 7.76071L4.39153 6.27933L4.26779 6.15559L4.14405 6.27933L3.61527 6.80811L3.49153 6.93185L3.61527 7.0556L5.74916 9.18949L5.87291 9.31323L5.99665 9.18949L10.0001 5.18609L10.1238 5.06235L10.0001 4.9386L9.47128 4.40983L9.34753 4.28608L9.22379 4.40983L5.87291 7.76071Z"
            fill="white"
            stroke="white"
            strokeWidth="0.35"
          />
        </mask>
        <g mask="url(#mask0_712_2906)">
          <path
            d="M11.217 2.66406H2.24341V11.6377H11.217V2.66406Z"
            fill="var(--chakra-colors-primaryColor)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_712_2906">
          <rect
            width="8.97363"
            height="8.97363"
            fill="white"
            transform="translate(2.24341 2.66406)"
          />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

const LightbulbIcon = ({ boxSize = 16, ...props }: IconProps) => (
  <Icon viewBox="0 0 16 16" {...props} boxSize={boxSize} fill="none">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 14.5H10.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.91874 10.4375C4.32349 9.97466 3.84138 9.38241 3.50894 8.70562C3.17651 8.02884 3.00246 7.28527 2.99999 6.53125C2.98749 3.81875 5.16874 1.5625 7.88124 1.5C8.93103 1.47512 9.96201 1.78138 10.828 2.37535C11.6939 2.96933 12.3509 3.82087 12.7057 4.8092C13.0605 5.79753 13.0951 6.87248 12.8047 7.8816C12.5142 8.89071 11.9134 9.78277 11.0875 10.4313C10.905 10.5723 10.7573 10.7532 10.6554 10.9601C10.5536 11.167 10.5004 11.3944 10.5 11.625V12C10.5 12.1326 10.4473 12.2598 10.3535 12.3536C10.2598 12.4473 10.1326 12.5 9.99999 12.5H5.99999C5.86738 12.5 5.74021 12.4473 5.64644 12.3536C5.55267 12.2598 5.49999 12.1326 5.49999 12V11.625C5.49843 11.3961 5.44537 11.1706 5.34475 10.965C5.24413 10.7594 5.09853 10.5791 4.91874 10.4375V10.4375Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50623 3.54999C9.11733 3.65358 9.68122 3.9443 10.1201 4.38203C10.5589 4.81975 10.8511 5.3829 10.9562 5.99374"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export {
  AddPanelsIcon,
  RemovePanelsIcon,
  RoofIcon,
  PanelLineGrabIcon,
  SummeryRoofIcon,
  SummaryLocationIcon,
  SummaryChoiceIcon,
  SummaryFormIcon,
  NorthIcon,
  SouthIcon,
  EditIcon,
  RotatePanelIcon,
  CalendarCheckmarkIcon,
  CheckMarkIcon,
  LocationIcon,
  LightbulbIcon,
};
